import Card from "@mui/material/Card";
import AuditLogAuditTrail from "./AuditLogAuditTrail";

const AuditLogTabs = ({ selectedTabIndex }) => {
    const tabsToPage = {
        0: <AuditLogAuditTrail />,
    };

    return <Card>{tabsToPage[selectedTabIndex] || null}</Card>;
};

export default AuditLogTabs;
